import { FC } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import { Anchor, Badge, Group, Text, Title, Tooltip } from "@mantine/core";

import { isValidUrl } from "@shared/utils";

import { HoverCopyButton } from "../HoverCopyButton";

export interface TitleRightIconProps {
  icon: IconProp;
  tooltip?: string;
  fontAwesomeIconProps?: Omit<FontAwesomeIconProps, "icon">;
}

export interface HoverCopyButtonTextProps {
  copyText?: string;
  tooltipText?: string;
}

interface TitleContainerProps {
  title: string;
  countBeforeTitle?: number;
  titleRightIconProps?: TitleRightIconProps;
  url?: string;
  hoverCopyButtonTextProps?: HoverCopyButtonTextProps;
  titleContentRight?: React.ReactNode;
}

export const TitleContainer: FC<TitleContainerProps> = ({
  title,
  countBeforeTitle,
  titleRightIconProps,
  url,
  hoverCopyButtonTextProps,
  titleContentRight,
}) => {
  return (
    <Group gap={6}>
      {countBeforeTitle && (
        <Badge
          variant="filled"
          color="gray.8"
          radius="sm"
          size="md"
          styles={{
            root: {
              height: "auto",
              padding: "1px 6px",
            },
            label: {
              fontWeight: 800,
              fontSize: 14,
            },
          }}
        >
          {countBeforeTitle}
        </Badge>
      )}
      {
        <HoverCopyButton {...hoverCopyButtonTextProps}>
          <Title fw={700} fz={20} c="dark.7">
            {url && isValidUrl(url) ? (
              <Anchor
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                size="xl"
                fw={600}
                c="blue.7"
              >
                {title}
              </Anchor>
            ) : (
              title
            )}
          </Title>
        </HoverCopyButton>
      }
      {titleRightIconProps && (
        <Tooltip
          label={titleRightIconProps.tooltip}
          disabled={!titleRightIconProps.tooltip}
          position="right"
          withinPortal
          withArrow
        >
          <FontAwesomeIcon
            {...titleRightIconProps.fontAwesomeIconProps}
            icon={titleRightIconProps.icon}
            style={{ color: "var(--mantine-color-gray-8)" }}
          />
        </Tooltip>
      )}

      {titleContentRight && (
        <Text c="dark.4" fw={400} fz={14} ml="md">
          {titleContentRight}
        </Text>
      )}
    </Group>
  );
};
